import React, { Component } from 'react';
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import axios from 'axios'
import Cache from '@aws-amplify/cache';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Login from './views/auth/login'

import { Header } from "./components/Header";
import { Sidebar } from "./components/Sidebar";
import { Dashboard } from "./views/Dashboard";
import { Orders } from "./views/Orders";
import { OrdersEdit } from "./views/OrdersEdit";
import { OrdersView } from "./views/OrdersView";
import { OrdersCreate } from "./views/OrdersCreate"
import { PriceLists } from "./views/PriceLists";
import { PriceListsEdit } from "./views/PriceListsEdit";
import { Catalogues } from "./views/Catalogues";
import { CataloguesEdit } from "./views/CataloguesEdit";
import { Products } from "./views/Products";
import { ProductsNew } from "./views/ProductsNew";
import { ProductsEdit } from "./views/ProductsEdit";
import { Categories } from "./views/Categories";
import { Customers } from "./views/Customers";
import { CustomersView } from "./views/CustomersView";
import { CustomersImport } from "./views/CustomersImport";
import { Profile } from "./views/Profile";
import { SettingsGeneral } from "./views/settings/general";
import { SettingsMyob} from "./views/settings/myob";
import { SettingsHolidays } from "./views/settings/holidays"
import { SettingsReporting } from "./views/settings/reporting"
import { SettingsPassword } from "./views/settings/password"
import { Onboarding } from "./views/Onboarding";
import { MyobOnboarding } from "./views/MyobOnboarding";
import { FreshProducePricing } from "./views/FreshProducePricing"
import { SettingsXero } from './views/settings/xero';
import { XeroOnboarding } from './views/XeroOnboarding';
import { CustomersImportXero } from './views/CustomersImportXero';

import GA from './utils/GoogleAnalytics'
// import FreshChat from './utils/Freshchat'
import Rollbar from './utils/RollbarTracking'

const config = require('./config.json')

axios.defaults.headers.common = {'Authorization': 'Bearer ' + Cache.getItem('supplier_auth_token')}
axios.defaults.baseURL = config.api2

// Set response to data
axios.interceptors.response.use(response => {
  return response.data;
})

Cache.configure({ defaultTTL: 1209600000 });

class App extends Component {

  state = {
    showSidebar: false,
    newUser: false,
    user: {},
    settings: {integration: {}},
    loggedIn: Cache.getItem('supplier_auth_token') ? true : false
  }

  componentDidMount() {
    this.fetchSettings()
  }

  fetchSettings = async () => {
    axios.get('/user')
    .then(data => {
      console.log(data[0]);
      this.setState({
        newUser: data[0].photo ? false : true,
        user: data[0],
        settings: JSON.parse(data[0].settings)
      });
    })
    .catch (err => {
      console.log(err);
      // Rollbar.error(err)
    })
  }

  toggleSidebar() {
    this.setState({showSidebar: !this.state.showSidebar})
  }

  render() {
    return (
    <div>
      {this.state.loggedIn ?
      <BrowserRouter>
        {this.state.newUser ? <Onboarding user={this.state.user}/> :
        <div>
          <Header toggleSidebar={this.toggleSidebar.bind(this)} user={this.state.user} />
          <div className="container-fluid">
            <div className="row">
              <Sidebar show={this.state.showSidebar} toggleSidebar={this.toggleSidebar.bind(this)} />
              <main role="main" className="col-md-10 ml-sm-auto col-lg-10 px-4">
                { GA.init() && <GA.RouteTracker /> }
                <Switch>
                  <Route exact path='/dashboard' render={(props) => (<Dashboard {...props} />)} />
                  <Route exact path='/orders' render={(props) => (<Orders {...props}  settings={this.state.settings} />)} />
                  <Route exact path='/orders/edit/:id' render={(props) => (<OrdersEdit {...props} user={this.state.user} settings={this.state.settings} />)} />
                  <Route exact path='/orders/view/:id' render={(props) => (<OrdersView {...props} user={this.state.user} settings={this.state.settings} />)} />
                  <Route exact path='/orders/create' render={(props) => (<OrdersCreate {...props} user={this.state.user} settings={this.state.settings} />)} />
                  <Route exact path='/pricelists' render={(props) => (<PriceLists {...props}  />)} />
                  <Route exact path='/pricelists/edit/:id' render={(props) => (<PriceListsEdit {...props} user={this.state.user} />)} />
                  <Route exact path='/catalogues' render={(props) => (<Catalogues {...props}  />)} />
                  <Route exact path='/catalogues/edit/:id' render={(props) => (<CataloguesEdit {...props}  />)} />
                  <Route exact path='/products' render={(props) => (<Products {...props} settings={this.state.settings} />)} />
                  <Route exact path='/products/new' render={(props) => (<ProductsNew {...props} user={this.state.user} />)} />
                  <Route exact path='/products/edit/:id' render={(props) => (<ProductsEdit {...props} user={this.state.user} />)} />
                  <Route exact path='/categories' render={(props) => (<Categories {...props} />)} />
                  <Route exact path='/customers' render={(props) => (<Customers {...props} user={this.state.user} settings={this.state.settings} />)} />
                  <Route exact path='/customers/import' render={(props) => (<CustomersImport {...props} user={this.state.user} />)} />
                  <Route exact path='/customers/import/xero' render={(props) => (<CustomersImportXero {...props} user={this.state.user} />)} />
                  <Route exact path='/customers/view/:id' render={(props) => (<CustomersView {...props} />)} />
                  <Route exact path='/profile' render={(props) => (<Profile {...props} user={this.state.user} />)} />
                  <Route exact path='/settings' render={(props) => (<SettingsGeneral {...props}  />)} />
                  <Route exact path='/settings/general' render={(props) => (<SettingsGeneral {...props}  />)} />
                  <Route exact path='/settings/myob' render={(props) => (<SettingsMyob {...props}  />)} />
                  <Route exact path='/settings/xero' render={(props) => (<SettingsXero {...props}  />)} />
                  <Route exact path='/settings/holidays' render={(props) => (<SettingsHolidays {...props}  />)} />
                  <Route exact path='/settings/reporting' render={(props) => (<SettingsReporting {...props}  />)} />
                  <Route exact path='/settings/password' render={(props) => (<SettingsPassword {...props}  />)} />
                  <Route exact path='/onboarding/myob' render={(props) => (<MyobOnboarding {...props} />)} />
                  <Route exact path='/onboarding/xero' render={(props) => (<XeroOnboarding {...props} refreshSettings={this.fetchSettings} />)} />
                  <Route exact path='/orders/freshproduce' render={(props) => (<FreshProducePricing {...props} />)} />
                  <Redirect exact from="/" to="/dashboard" />
                </Switch>
                <hr className="mt-05"/>
                <p className="text-center text-muted">&copy; {new Date().getFullYear()} OrderFresh <a href="mailto:support@orderfresh.com.au">Support</a></p>
              </main>
            </div>
          </div>
          <ToastContainer />
          {/* <FreshChat
            token="d39f6dec-d41b-4e88-b1b4-13fffecd70ab"
            onInit={widget => {
              widget.user.setFirstName(this.state.user.name);
              widget.user.setEmail(this.state.user.email);
            }}
          /> */}
        </div>}
      </BrowserRouter> : <Login />}
    </div>
    );
  }
}

export default App;
